module.exports = "https://s91588.cdn.ngenix.net/home/_next/static/images/mortgage-insurance@2x-2ec320fd9202394dfdfb88ef5c499c6d.png";